import { Link } from 'react-router-dom';
import { plotEpisodes } from '@/mocks/plotEpisodes';
import { episodeNo } from '@/utils/format';

export default function PlotPreview() {
  const preview = plotEpisodes.slice(0, 3);

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-10 md:px-8 md:py-14">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs tracking-[0.24em] text-primary-600">EPISODE GUIDE</p>
            <h2 className="mt-2 font-heading text-xl text-foreground-950 md:text-2xl">剧情速览</h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-500">
            十二集，一条慢慢被打开的裂缝。先看开篇三集，再决定要不要一次读完。
          </p>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
          {preview.map((item) => (
            <Link
              key={item.id}
              to={`/detail/plot/${item.id}`}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="h-[160px] w-full overflow-hidden bg-background-200 md:h-[180px]">
                <img
                  src={item.image}
                  alt={`${episodeNo(item.episode)} ${item.title} 剧照`}
                  title={`${item.title} - 禁止的爱善良的小姨子剧情`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between text-[11px]">
                  <span className="tracking-wide text-primary-600">{episodeNo(item.episode)}</span>
                  <span className="text-foreground-400">{item.duration}</span>
                </div>
                <h3 className="mt-2 font-heading text-base text-foreground-900 transition-colors group-hover:text-primary-600">
                  {item.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">{item.summary}</p>
                <span className="mt-3 flex items-center gap-1 text-xs text-accent-700">
                  阅读本集
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6">
          <Link
            to="/category/plot"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-500 hover:text-primary-600"
          >
            查看全部分集剧情
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}